import { render, staticRenderFns } from "./ratingDisplay.vue?vue&type=template&id=48e1a890&"
import script from "./ratingDisplay.vue?vue&type=script&lang=js&"
export * from "./ratingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports